var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_3055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9444 26.8886C21.0933 26.8886 26.8886 21.0933 26.8886 13.9443C26.8886 6.79536 21.0933 1 13.9444 1C6.79542 1 1 6.79536 1 13.9443C1 21.0933 6.79542 26.8886 13.9444 26.8886Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6182 5.19092V16.0994L18.6769 19.131",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_3055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8887,
    height: 27.8887,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeTime);
export default __webpack_public_path__ + "static/media/icon_type_time.c20e5174455a51ea0511e8f07eb81ccf.svg";
export { ForwardRef as ReactComponent };